import React from 'react';
import {
  CRow,
  CSpinner
} from '@coreui/react'

const LoadingFallback = ()=> {

    return (
        <CRow className="justify-content-center">
            <CSpinner
            color="primary"
            style={{width:'4rem', height:'4rem'}}
            />
        </CRow>

        // <div className="pt-3 text-center">
        //     <div className="sk-spinner sk-spinner-pulse"></div>
        // </div>

    )

}

export default LoadingFallback



